import { render, staticRenderFns } from "./best-match.vue?vue&type=template&id=61a03fb2&scoped=true&"
import script from "./best-match.vue?vue&type=script&lang=js&"
export * from "./best-match.vue?vue&type=script&lang=js&"
import style0 from "./best-match.vue?vue&type=style&index=0&id=61a03fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a03fb2",
  null
  
)

export default component.exports